import type { FC } from 'react';
import React from 'react';
import Modal from 'react-responsive-modal';

interface Props {
  isMobile: boolean;
  isOpen: boolean;
}

const Styles = {
  position: 'relative',
  flexDirection: 'column',
  display: 'flex',
  width: '100vw',
  height: '100vh',
  margin: 0,
  padding: 0,
  zIndex: 9999,
};

export const Container: FC<Props> = ({ isMobile, isOpen, children }) =>
  isMobile ? (
    <Modal
      styles={{ modal: Styles, overlay: { padding: 0, zIndex: 9999 } }}
      onClose={() => undefined}
      open={isOpen}
    >
      {children}
    </Modal>
  ) : (
    <>{children}</>
  );
